import React, { useState, useEffect } from 'react'

import {Grid} from '@mui/material'

import ComponentContainer from '../../core/template/ComponentContainer';
import {CoreContext} from "../../core/context/CoreContext";
import TemplateEditFormImpl from './TemplateEditFormImpl';
import TemplateList from './TemplateList';
import { useSelector, useDispatch } from 'react-redux';

import Notification from '../../core/components/Notification';

import TemplateListView from './TemplateListView'


export default function TemplateDashboard(){
  const { setKeyValue, getKeyValues, keyvalues } = React.useContext(CoreContext);
  const {showEdit} = useSelector((state)=>state.manufslice.templateDashboard);
  const [ templateId, setTemplateId] = React.useState('');
  const [reloadTemplateList, setReloadTemplateList] = useState(true);

  return (
      <>
      <Notification/>
      {showEdit?
        <ComponentContainer containedComponent = {
          <TemplateEditFormImpl 
            setReloadTemplateList={setReloadTemplateList}
            templateId={templateId}
            />}/>:
            <>
            <Grid container direction="column" >
              <Grid item>
                    {
                      <TemplateListView 
                      setTemplateId = {setTemplateId}/>
                    }
              </Grid>
            </Grid>
            </>
      }
    </>


  )

}
